import { orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";

interface WorkListingsQueryOptionsInput {
  workId: string;
  currency: string;
  enabled?: boolean;
}

export function getWorkListingsQueryOptions({
  workId,
  currency,
  enabled,
}: WorkListingsQueryOptionsInput) {
  return orpc.marketplace.getListingsForWork.queryOptions({
    input: { workId, currency },
    enabled,
    staleTime: QUERY_STALE_TIMES.marketplaceListings,
  });
}
